module.exports = __webpack_public_path__ + "img/activityIcon.576bede0.png";